export default "__VITE_ASSET__K6DFxM0j__"